import { render, staticRenderFns } from "./RenewalInplayMobileList.vue?vue&type=template&id=0725bbe4&scoped=true"
import script from "./RenewalInplayMobileList.vue?vue&type=script&lang=js"
export * from "./RenewalInplayMobileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725bbe4",
  null
  
)

export default component.exports